import { render, staticRenderFns } from "./CartDeliveryFrom.vue?vue&type=template&id=b40407ae&scoped=true&"
import script from "./CartDeliveryFrom.vue?vue&type=script&lang=js&"
export * from "./CartDeliveryFrom.vue?vue&type=script&lang=js&"
import style0 from "./CartDeliveryFrom.vue?vue&type=style&index=0&id=b40407ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40407ae",
  null
  
)

export default component.exports
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QChip});
